import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function GeceDusunmeTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['gece-dusunme-testi']} />;
}
